<div  [ngStyle]="{'padding-right': gridInfo['gutterHorizontal'], 'padding-left': gridInfo['gutterHorizontal']}">
  <ul [class]="key" class="list-unstyled px-0 row row-cols-{{gridInfo['itemsPerRow']}} justify-content-{{gridInfo['justifyContent']}}"
    [ngStyle]="{'margin-right': '-'+(gridInfo['gutterHorizontal']), 'margin-left': '-'+(gridInfo['gutterHorizontal'])}">
    @for (item of items; track item; let i = $index; let first = $first) {
      <li [ngClass]="{'active' : first , 'col' : gridInfo['itemsPerRow'], 'col-auto' : !gridInfo['itemsPerRow']}"
        [ngStyle]="{'padding': gridInfo['gutterHorizontal']+' '+ gridInfo['gutterVertical']}">
        @if ((templates$|async)?.[item.entity_preview_var_s || pageData.entityPreviewVar]) {
          <div
          [innerHtml]="(templates$|async)[item.entity_preview_var_s || pageData.entityPreviewVar] | replaceTokensArray: {keys: item, previewVar: item.entity_preview_var_s || pageData.entityPreviewVar} | safe: 'html'"></div>
        } @else {
          <a [download]="item.filename_display_s" [href]="item['download_url']">
            {{item['filename_display_s'] || item['filename_s']}}
          </a>
        }
      </li>
    }
  </ul>
</div>
